import { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import contactImg from "../assets/contact-img.png";

const REASONS = [
  "Questions about our articles or explanations",
  "Suggestions for new finance topics",
  "Feedback on content accuracy or clarity",
  "General website-related inquiries",
];

function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [validated, setValidated] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    if (formEl.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    // No backend yet — we simply acknowledge the message locally.
    setSent(true);
    setForm({ name: "", email: "", phone: "", message: "" });
    setValidated(false);
  };

  return (
    <Container className="py-5">
      {/* Form + illustration */}
      <Row className="align-items-center g-5">
        <Col lg={6}>
          <Card className="fi-card">
            <Card.Body className="p-4 p-md-5">
              <h2 className="text-center fw-bold mb-4">Contact Us</h2>
              {sent && (
                <Alert variant="success" onClose={() => setSent(false)} dismissible>
                  ✅ Thank you! Your message has been received. We'll reply soon.
                </Alert>
              )}
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Full Name</Form.Label>
                  <Form.Control
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    placeholder="Your Name"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter your name.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    placeholder="Email Address"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid email.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Phone Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                    placeholder="Type Your Message"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please write a message.
                  </Form.Control.Feedback>
                </Form.Group>

                <Button type="submit" className="btn-green w-100 rounded-3 py-2">
                  Submit
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6} className="text-center">
          <img
            src={contactImg}
            alt="We're here to help"
            className="img-fluid rounded-4 "
            style={{ maxHeight: 450, objectFit: "cover" }}
          />
        </Col>
      </Row>

      {/* Info sections */}
      <Row className=" mt-5">
        <Col lg={10} className="fi-article">
          <h2>We're Here to Help</h2>
          <p>
            Have a question about our content or need clarification on a finance
            topic? We're always happy to hear from our users.
          </p>
          <p>
            At this website, we focus on providing clear and easy-to-understand
            financial information. If something on our website needs improvement
            or you have a suggestion, feel free to reach out using the contact form.
          </p>

          <h2>What You Can Contact Us For</h2>
          <p>You can contact us regarding:</p>
          <ul>
            {REASONS.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
          <p>
            We carefully review every message to ensure our content remains
            helpful and reliable.
          </p>

          <h2>Our Commitment</h2>
          <p>
            We are committed to maintaining transparency, accuracy and user trust.
            Your feedback plays an important role in helping us improve and grow as
            an educational platform.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default ContactUs;
